import primaryButton from '../../../../primary-button';

const dark = (params) => primaryButton.brandedSolid.background.default.dark(params);

export default dark;
